import React from 'react';
import {
  HStack,
  VStack,
  Box,
  Image,
  Text,
  SimpleGrid,
  List,
  ListItem,
  ListIcon,
  OrderedList,
  UnorderedList,
} from '@chakra-ui/react';
import { Link } from '@chakra-ui/react';
import b1 from '../img/book/1.jpg';
import b2 from '../img/book/2.1.png';
import b3 from '../img/book/3.2.jpg';
import b4 from '../img/book/4.jpg';
import b5 from '../img/book/5.1.png';
import b6 from '../img/book/6.jpg';
import b7 from '../img/book/7.1.jpeg';
import b8 from '../img/book/8.jpg';
import b9 from '../img/book/9.png';
import b10 from '../img/book/10.jpg';
import b11 from '../img/book/11.jpg';
import b12 from '../img/book/12.jpg';
const Books = () => {
  return (
    <>
      <VStack spacing={4}  alignItems={'center'} >
        {/* ---------------------book1--------------------- */}
        <Box>
          <HStack spacing="10px">
            {/* ********* 1 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              borderColor="lightgray"
              bg={'#fff'}
              overflow="hidden"
                      height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b1} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="right">
                  <Box>
                    <Text as="b" >
                      العنوان:&nbsp;
                      <span>حُب</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة الاصلية:&nbsp;
                      <span>الاسبانية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المترجم:&nbsp;
                      <span>محمد الفولي</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المؤلف:&nbsp;
                      <span>سارة ميسا</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      الدار:&nbsp;
                      <span>أثر</span>
                    </Text>
                   
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 2 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                         height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b2} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b" >
                      العنوان:&nbsp;
                      <span>المشي فلسفة</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة الاصلية:&nbsp;
                      <span>الفرنسية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المترجم:&nbsp;
                      <span>سعيد بوكرامي</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المؤلف:&nbsp;
                      <span>فريدريك غرو</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      الدار:&nbsp;
                      <span>منصة معنى</span>
                    </Text>
        
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 3 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              bg={'#fff'}
              borderRadius="10px"
              borderColor="lightgray"
              overflow="hidden"
                         height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b3} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b"  >
                      العنوان:&nbsp;
                      <span>كيف تكون معلمًا بارعًا</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة الاصلية:&nbsp;
                      <span>الإنجليزية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المترجم:&nbsp;
                      <span>عصام فاروق صالح</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      اسم المؤلف:&nbsp;
                      <span>دوغ ليموف</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b"  >
                      الدار:&nbsp;
                      <span>العبيكان</span>
                    </Text>
                    <Text color={'red'}> رقم الجناح: U27 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
          </HStack>
        </Box>
        {/* ---------------------book2--------------------- */}
        <Box>
          <HStack spacing="24px">
            {/* ********* 1 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                             height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b4} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b" >
                      العنوان:&nbsp;
                      <span>السعودية المتغيرة</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة الاصلية:&nbsp;
                      <span>الإنجليزية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المترجم:&nbsp;
                      <span>د.نهى عبدالله العويضي</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المؤلف:&nbsp;
                      <span>د.شون فولي</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      الدار: &nbsp;
                      <span>دار أدب</span>
                    </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 2 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                             height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b5} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b" >
                      العنوان: &nbsp;
                      <span> تدريس علم الأخلاف في المدارس</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة الاصلية:&nbsp;
                      <span>الإنجليزية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المترجم:&nbsp;
                      <span>مروان الرشيد</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المؤلف:&nbsp;
                      <span> د.فيليب كام </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      الدار:&nbsp;
                      <span>بصيرة</span>
                    </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 3 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                             height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b6} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b" >
                      العنوان:&nbsp;
                      <span>أنا الإمبراطور</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة الاصلية:&nbsp;
                      <span>الفرنسية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المترجم:&nbsp;
                      <span> وليد بن أحمد</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المؤلف:&nbsp;
                      <span>هوجو هوريو</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      الدار:&nbsp;
                      <span>ترياق</span>
                    </Text>
      
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
          </HStack>
        </Box>
        {/* ---------------------book3--------------------- */}
        <Box>
          <HStack spacing="24px">
            {/* ********* 1 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                             height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b7} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b" >
                      العنوان:&nbsp;
                      <span>حرب الفقراء</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة الاصلية:&nbsp;
                      <span>الفرنسية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المترجم:&nbsp;
                      <span>د.أيمن منير</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المؤلف:&nbsp;
                      <span>أيرك فويار</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      الدار:&nbsp;
                      <span>ميلاد</span>
                    </Text>
                    <Text color={'red'}> رقم الجناح: E12 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 2 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                             height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b8} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b" >
                      العنوان:&nbsp;
                      <span>أمل</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة الاصلية:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة المترجم اليها:&nbsp;
                      <span>الإنجليزية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المترجم:&nbsp;
                      <span>علوية الحسان</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المؤلف:&nbsp;
                      <span>امل ناصر</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      الدار:&nbsp;
                      <span>حكاية قمر</span>
                    </Text>
                    <Text color={'red'}> رقم الجناح: N14 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 3 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                             height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b9} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b" >
                      العنوان:&nbsp;
                      <span>الحياة الأنسانية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة الاصلية:&nbsp;
                      <span>الفرنسية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المترجم:&nbsp;
                      <span>يوسف أشلحي</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المؤلف:&nbsp;
                      <span>اندري كونت سبونفيل</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      الدار:&nbsp;
                      <span>صفحة سبعة</span>
                    </Text>
                    <Text color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
          </HStack>
        </Box>
        {/* ---------------------book4--------------------- */}
        <Box>
          <HStack spacing="24px">
            {/* ********* 1 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                             height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b10} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b" >
                      العنوان:&nbsp;
                      <span>وجه القمر الآخر </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة الاصلية:&nbsp;
                      <span>الفرنسية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المترجم:&nbsp;
                      <span>د.خليد كدري</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المؤلف:&nbsp;
                      <span> كلود ليفي-ستروس</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      الدار:&nbsp;
                      <span>صفحة 7</span>
                    </Text>
                    <Text color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 2 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                             height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b11} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b" >
                      العنوان:&nbsp;
                      <span>أطلس متململا - الجزء الثاني</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة الاصلية:&nbsp;
                      <span>الإنجليزية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المترجم:&nbsp;
                      <span> خالد حافظي</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المؤلف:&nbsp;
                      <span> آين راند</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      الدار:&nbsp;
                      <span> صفحة سبعة</span>
                    </Text>
                    <Text color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
            {/* ********* 3 ********* */}
            <Box
              maxW="sm"
              borderWidth="1px"
              borderRadius="10px"
              bg={'#fff'}
              borderColor="lightgray"
              overflow="hidden"
                           height={["85vh","95vh"]} w={'25vw'}
            >
              <Image src={b12} alt={'books'} w={'100%'} h={'400px'} />

              <Box p="6">
                <VStack spacing={4} align="stretch">
                  <Box>
                    <Text as="b" >
                      العنوان:&nbsp;
                      <span>اطلس متململا - الجزء الثالث </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة الاصلية:&nbsp;
                      <span>الإنجليزية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اللغة المترجم اليها:&nbsp;
                      <span>العربية</span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المترجم:&nbsp;
                      <span>خالد حافظي </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      اسم المؤلف:&nbsp;
                      <span> آين راند </span>
                    </Text>
                  </Box>
                  <Box>
                    <Text as="b" >
                      الدار:&nbsp;
                      <span>صفحة سبعة</span>
                    </Text>
                    <Text color={'red'}> رقم الجناح: D22 </Text>
                  </Box>
                </VStack>

                <Box display="flex" alignItems="baseline"></Box>
              </Box>
            </Box>
          </HStack>
        </Box>
      </VStack>
    </>
  );
};

export default Books;
